// extracted by mini-css-extract-plugin
module.exports = {"container":"MainBoard_container__15Q2m","backdrop":"MainBoard_backdrop__1fDgE"};